var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8659 3.80624C11.0359 3.97539 11.0359 4.24962 10.8659 4.41877L5.09711 10.1587C4.92711 10.3278 4.65149 10.3278 4.4815 10.1587C4.3115 9.98954 4.31151 9.7153 4.4815 9.54616L10.2503 3.80624C10.4203 3.6371 10.6959 3.6371 10.8659 3.80624Z",
    fill: "#7D899D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48155 3.84126C4.65154 3.67211 4.92716 3.67211 5.09715 3.84126L10.8659 9.58118C11.0359 9.75032 11.0359 10.0246 10.8659 10.1937C10.6959 10.3628 10.4203 10.3628 10.2503 10.1937L4.48155 4.45378C4.31155 4.28464 4.31155 4.0104 4.48155 3.84126Z",
    fill: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIconSmall);
export default __webpack_public_path__ + "static/media/cancel-icon-small.74616e91.svg";
export { ForwardRef as ReactComponent };